import ReviewsController from './reviews.controller.js';
import ReviewController from './review.controller.js';
import ReviewEditController from './review-edit.controller.js';

import reviewsTpl from './reviews.html';
import reviewTpl from './review.html';
import reviewEditTpl from './review.edit.html';

export default function reviewsRouter($stateProvider, $urlRouterProvider) {
  $stateProvider
    .state('app.reviews', {
      url: '/reviews',
      templateUrl: reviewsTpl,
      controller: ReviewsController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['REVIEW_READ', 'REVIEW_READ_SUBMITTED_ONLY'],
      },
    })
    .state('app.review', {
      url: '/review',
      templateUrl: reviewTpl,
      controller: ReviewController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['REVIEW_UPDATE'],
      },
    })
    .state('app.review.edit', {
      url: '/:reviewId/edit',
      templateUrl: reviewEditTpl,
      params: {
        reviewId: null,
        review: null,
      },
      controller: ReviewEditController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['REVIEW_UPDATE'],
      },
    });
}



// WEBPACK FOOTER //
// ./src/app/reviews/reviews.router.js